import { render } from "./AddFavorito.vue?vue&type=template&id=0c889fa0"
import script from "./AddFavorito.vue?vue&type=script&lang=js"
export * from "./AddFavorito.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__